import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Chip } from 'primereact/chip';
import { chatFiltersNames } from './chat-filter-constant';
import "./style.css";
import { ChangeAgentChatStatus } from '../../../../reducers/enqChatSlice';

const ChatFilter = () => {
    const { agentChatStatus } = useSelector(state => state.enqChats)
    const dispatch = useDispatch();
    const handleChange = (newValue) => {
        dispatch(ChangeAgentChatStatus(newValue))
    }

    useEffect(()=>{
        return ()=>{
        dispatch(ChangeAgentChatStatus('all'))
        }
    },[])
    return (
        <div className='chat-filter-container'>
            <div className='flex gap-2 px-2 py-1 overflow-x-auto no-wrap' >
                {
                    chatFiltersNames?.map(item => <Chip key={item.value} label={item.label} onClick={() => handleChange(item.value)} className={`cursor-pointer ${item.value} ${agentChatStatus === item.value && "selected-filter"}`} />)
                }
            </div>

        </div>

    )
}

export default ChatFilter;